module.exports = __webpack_public_path__ + "images/emoji/blue_car.783e9aff044720cf3c13.png";